module.exports = {
  programmeMemorandumUrl: 'https://wecantokenize-test.s3.amazonaws.com/docs/Programme%20Memorandum.pdf'
};